// app
export const RESIZE = 'RESIZE'
export const APP_FETCHED = 'APP_FETCHED'
export const SET_IMAGES = 'SET_IMAGES'
export const FILTER_IMAGES = 'FILTER_IMAGES'
export const UPDATE_COLOR = 'UPDATE_COLOR'
export const UPDATE_MASK = 'UPDATE_MASK'



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js